<template>
  <div class="Rank-container">
    <rank-header
      class="rank-header-class"
      :masterList="masterList2.slice(0, 3)"
      :historyWord="this.showingWords"
    >
    </rank-header>
    <rank-master-list :masterList="this.masterList2"></rank-master-list>
  </div>
</template>

<script>
import RankMasterList from '@/views/Rank/components/rank-master-list'
import RankHeader from '@/views/Rank/components/rank-header'
import { getBjhRankMasterList, getBjhRankHistoryList } from '@/api/article'
import { monthAndDay } from '@/utils/dayjs'

export default {
  name: 'RankIndex',
  components: {
    RankMasterList,
    RankHeader
  },
  props: {},
  data() {
    return {
      history1: {},
      masterList2: [],
      showingWords: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    this.loadHistory()
  },
  mounted() {},
  methods: {
    async onLoad2() {
      const { data } = await getBjhRankMasterList({
        // startDate: this.history1.startDate,
        // endDate: this.history1.endDate,
        // count: 10
        period: this.history1.period
      })
      console.log(data)
      this.masterList2 = data
    },

    async loadHistory() {
      const { data } = await getBjhRankHistoryList()
      // this.history1 = data.data[0]
      this.history1 = data[0]
      var showing = `第${data[0].period}期榜单（${monthAndDay(
        data[0].beginDate
      )}-${monthAndDay(data[0].endDate)}）`
      this.showingWords = showing
      // console.log(this.showingWords)
      this.onLoad2()
    }
  }
}
</script>

<style lang="less" scoped>
// .Rank-container{
//   width: 100%;
//   height: 100%;
//  color: white;
// }
</style>
